var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscSorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07271 3.82232L3.50313 1.46545L5.93356 3.82232C6.17785 4.05923 6.57248 4.05923 6.81678 3.82232C7.06107 3.58542 7.06107 3.20273 6.81678 2.96583L3.94161 0.177676C3.69731 -0.0592266 3.30268 -0.0592265 3.05839 0.177676L0.183222 2.96583C-0.0610726 3.20274 -0.0610725 3.58542 0.183223 3.82233C0.427518 4.05315 0.828413 4.05923 1.07271 3.82232Z",
    fill: "#353434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscSorted);
export default __webpack_public_path__ + "static/media/asc-sorted.38cd5dbb9271e81278964fe33e1e44bb.svg";
export { ForwardRef as ReactComponent };